import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import {
  EmailTemplateLanguageType,
  IEmailTemplate,
  IEmailTemplateForTable,
  IEmailTemplateSubject,
  IEmailTemplateVersion,
} from "../../models/EmailTemplate";
import { EmailTemplateService } from "../../services/email-template.service";
import { IEmailTemplateParams } from "../types";

export const useGetEmailTemplateVersionByLanguageQuery = (
  emailTemplateId: string,
  language: EmailTemplateLanguageType
) => {
  return useQuery<IEmailTemplateVersion, Error>({
    queryKey: [QUERY_CONSTANTS.GET_EMAIL_TEMPLATE_VERSION_BY_LANGUAGE, emailTemplateId, language],
    queryFn: () =>
      EmailTemplateService.getEmailTemplateVersionByLanguage(emailTemplateId, language).then(
        (res) => res.data
      ),
    enabled: !!emailTemplateId && emailTemplateId !== "new",
  });
};

export const useGetEmailTemplateSubjectsQuery = () => {
  return useQuery<IEmailTemplateSubject[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_EMAIL_TEMPLATE_SUBJECTS],
    queryFn: () => EmailTemplateService.getEmailTemplateSubjects().then((res) => res.data),
  });
};

export const useGetEmailTemplateConstantsQuery = (subject?: string) => {
  return useQuery<string[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_EMAIL_TEMPLATE_CONSTANTS, subject],
    queryFn: () => EmailTemplateService.getEmailTemplateConstants(subject).then((res) => res.data),
    staleTime: Infinity,
  });
};

export const useGetAllEmailTemplatesQuery = (data: IEmailTemplateParams) => {
  return useQuery<{ items: IEmailTemplateForTable[]; total: number }, Error>({
    queryKey: [QUERY_CONSTANTS.GET_ALL_EMAIL_TEMPLATES, data],
    queryFn: () =>
      EmailTemplateService.getAllEmailTemplates(data.currentPage, data.pageSize).then(
        (res) => res.data
      ),
  });
};

export const useGetEmailTemplateByIdQuery = (id: string) => {
  return useQuery<IEmailTemplate, Error>({
    queryKey: [QUERY_CONSTANTS.GET_EMAIL_TEMPLATE_BY_ID, id],
    queryFn: () => EmailTemplateService.getEmailTemplateById(id).then((res) => res.data),
    enabled: !!id,
  });
};
